import {CLOUD_TYPES} from "../../../../../utils/const/createEnvConsts";

export const getEnvironmentURL = (environmentData) => {
  if(!environmentData){
      return '';
  }

  const {cloudType, tokenId, staticLink} = environmentData;
  let link = '';

  if(cloudType === CLOUD_TYPES.CLOUDSHARE){
      link = tokenId ? 'https://use.cloudshare.com//Ent/Login.mvc/SponsoredLogin?token=' + tokenId : '';
  }
  else if(cloudType === CLOUD_TYPES.GOOGLE || cloudType === CLOUD_TYPES.SPEKTRA){
      link = tokenId;
  }
  else if(cloudType === CLOUD_TYPES.STATIC){
      link = staticLink;
  }

  return link;

}
